import { createContext, FC, ReactNode, useReducer } from "react";
import { NetworkSubmissionWizardState, networkSubmissionWizardInitialState } from "@app/compliance-connect/network-submission/networkSubmissionWizardState";
import { NetworkSubmissionWizardActions } from "@app/compliance-connect/network-submission/networkSubmissionWizardActions";
import { networkSubmissionWizardReducer } from "@app/compliance-connect/network-submission/networkSubmissionWizardReducer";

interface NetworkSubmissionContextProps extends NetworkSubmissionWizardState {
  dispatch: React.Dispatch<NetworkSubmissionWizardActions>;
}

interface NetworkSubmissionContextProviderProps {
  children: ReactNode;
}

const NetworkSubmissionContext = createContext<NetworkSubmissionContextProps>({} as NetworkSubmissionContextProps);

const NetworkSubmissionContextProvider: FC<NetworkSubmissionContextProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(networkSubmissionWizardReducer, networkSubmissionWizardInitialState);

  return (
    <NetworkSubmissionContext.Provider value={{ ...state, dispatch }}>
      {children}
    </NetworkSubmissionContext.Provider>
  );
};

export {
  NetworkSubmissionContext,
  NetworkSubmissionContextProps,
  NetworkSubmissionContextProvider,
};
